import { EpisodeCategory } from '../../common/enums/episodeCategory';

export function isOpenActiveProcessesEnabledByEpisodeCategory(episodeCategory: EpisodeCategory) {
    return [EpisodeCategory.ophthalmology, EpisodeCategory.mentalHealth].includes(episodeCategory);
}
